export default "__VITE_ASSET__CwXldqWh__"